<template>
    <div class="home">
        <v-row class="mx-0">
            <home-banner
                @arrow-click="scrollTo('calculator')"
            ></home-banner>

            <home-calculator
                ref="calculator"
            ></home-calculator>

            <home-products
                v-if="popularProducts.length"
                :title="$t('mostPopularProducts')"
                :products="popularProducts"
            ></home-products>

            <home-products
                v-if="discountProducts.length"
                :title="$t('productsWithDiscount')"
                :products="discountProducts"
            ></home-products>

            <v-container class="app-container py-10">
                <v-row>
                    <v-col cols="12" sm="12" md="6" v-for="attribute in popularAttributes" :key="attribute.id">
                        <home-attributes
                            :title="attribute.lang_name"
                            :attributes="attribute.sub"
                        ></home-attributes>
                    </v-col>
                </v-row>
            </v-container>

            <home-manufacturers></home-manufacturers>

            <home-content
                :content="content"
            ></home-content>

            <!--<home-benefits
                @open-seller-dialog="$store.commit('sellerRegDialogShow')"
            ></home-benefits>-->

            <home-partners></home-partners>

            <home-questions
                @open-faq-dialog="faqDialogOpen = true"
            ></home-questions>
        </v-row>

        <seller-registration></seller-registration>

        <faq-button-dialog
            :isOpen="faqDialogOpen"
            @close="faqDialogOpen = false"
        ></faq-button-dialog>
    </div>
</template>

<script>
    import AppVariables from '../../../app-front/mixins/AppVariables';
    import FaqButtonDialog from '../../../app-front/components/dialogs/FaqButtonDialog';
    import HomeAttributes from './HomeAttributes';
    import HomeBanner from './HomeBanner';
    // import HomeBenefits from './HomeBenefits';
    import HomeCalculator from './HomeCalculator';
    import HomeContent from './HomeContent';
    import HomeManufacturers from './HomeManufacturers';
    import HomePartners from './HomePartners';
    import HomeProducts from './HomeProducts';
    import HomeQuestions from './HomeQuestions';
    import SellerRegistration from '../../../app-front/components/dialogs/SellerRegistration';
    import productService from '../../../app-front/services/api/ProductService';
    import infoService from '../../../app-front/services/api/InfoService';
    import './home.scss'

    export default {
        name: 'Home',
        mixins: [AppVariables],
        components: {
            FaqButtonDialog,
            HomeAttributes,
            HomeBanner,
            // HomeBenefits,
            HomeCalculator,
            HomeContent,
            HomeManufacturers,
            HomePartners,
            HomeProducts,
            HomeQuestions,
            SellerRegistration,
        },
        data() {
            return {
                metaUrl: '/homepage',
                faqDialogOpen: false,
                popularProducts: [],
                discountProducts: [],
                popularAttributes: [],
            }
        },
        computed: {
            content() {
                return this.$store.state.baseInfo.content.map(item => ({
                    ...item,
                    image: `${this.getCdnPath()}/icons/${item.image}`
                }));
            }
        },
        created() {
            productService.setLocale(this.$store.state.language.appLanguage);

            productService.getPopularProducts()
                .then(res => {
                    this.popularProducts = res.data.data;
                })
                .catch(console.log);

            productService.getDiscountProducts()
                .then(res => {
                    this.discountProducts = res.data.data;
                })
                .catch(console.log);

            infoService.getPopularAttributes()
                .then(res => {
                    this.popularAttributes = res.data;
                })
                .catch(console.log)
        },
        methods: {
            scrollTo(refName) {
                this.$refs[refName]?.$el?.scrollIntoView({
                    behavior: 'smooth',
                });
            }
        },
    }
</script>

<style scoped>

</style>
